import { GameState, gameStates } from './machine/state-types';
import { allowToBet, gameRoundInfo } from '../store';
import { backend } from '../backend';
import { applyTopSlotToBonusGame, waitEnd, waitForBonusTransitionToFinish, waitForPlayClick } from './machine/helpers';
import { EventEmitterInstance } from '../utils/event-emitter';
import { playAudio, getAudio, stopAudio } from '../utils/audio';

let timer1;
let timer2;

export const state: GameState = {
    name: gameStates.wheelOfFortune,
    onEnter: async setState => {
        await waitForBonusTransitionToFinish();
        playAudio('audio_wof_appears');
        await applyTopSlotToBonusGame();

        await waitForPlayClick();
        allowToBet.set(false);

        const result = await backend.playBonus('FORTUNE_WHEEL');
        gameRoundInfo.set(result);

        EventEmitterInstance.emit('response-bonus-fortune-wheel', result);

        playRotateWheelSounds();

        await waitEnd();

        if (result.resp.fortune_wheel_result.sector == 'DOUBLE') playAudio('audio_wof_double_win');

        if (result.final) setState(gameStates.bigWin);
        else {
            setState(gameStates.wheelOfFortuneDouble);
        }
    },
    onExit: () => {
        //TODO unsubscribe

        clearTimeout(timer1);
        clearTimeout(timer2);
    }
};

function playRotateWheelSounds() {
    playAudio('audio_wof_start');
    timer1 = setTimeout(() => {
        playAudio('audio_wof_spin', { volume: 0.25, loop: true, fade: null });
        timer2 = setTimeout(() => {
            stopAudio(getAudio('audio_wof_spin'));
            playAudio('audio_wof_stop'); //5540
        }, 3460);
    }, 625);
}
